import type { GridColDef } from "@mui/x-data-grid-premium";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { ObjectClassDefinitionInfo } from "../../../../api/types/objectTypes";
import ObjectNameCell from "./ObjectNameCell";
import ObjectSourceBadge from "./ObjectSourceBadge";

export const columnDefinitions: GridColDef<ObjectClassDefinitionInfo>[] = [
  {
    field: "objectName",
    headerName: "Object Type",
    sortable: false,
    flex: 1,
    minWidth: 160,
    renderCell: ({ row }) => <ObjectNameCell row={row} />,
  },
  {
    field: "source",
    headerName: "Source",
    sortable: false,
    flex: 0.5,
    minWidth: 100,
    renderCell: ({ row }) => <ObjectSourceBadge objectSource={row.source} />,
  },
  {
    field: "updateAt",
    headerName: "Modified at",
    sortable: false,
    flex: 0.5,
    minWidth: 160,
    valueFormatter: (value) => (value ? convertISODateTime(value) : "-"),
  },
];
